var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPropsCons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 186,
    viewBox: "0 0 255 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.264 26.3984L134.264 171.692",
    stroke: "url(#paint0_linear_952_1983)",
    strokeWidth: 4.83555
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2944 56.6652C74.7164 48.6082 97.4115 19.6032 132.372 27.1859L135.424 41.4726C125.53 44.8079 116.596 41.457 100.628 44.8676C84.6598 48.2782 78.3665 60.1805 63.0922 65.0627C47.2736 70.1189 36.329 62.6384 32.2212 60.1824C33.2241 58.9589 33.3553 58.6177 35.0438 56.6215C41.2965 60.2973 53.8724 64.7223 64.2944 56.6652Z",
    fill: "url(#paint1_linear_952_1983)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.549 26.2816C193.745 23.1855 161.18 5.98353 132.368 27.1875L135.42 41.4742C145.813 40.4764 152.598 33.7679 168.566 30.3573C184.534 26.9467 195.141 35.2392 211.077 33.4551C227.581 31.6074 234.514 20.3084 237.26 16.3884C235.845 15.6814 235.586 15.4236 233.229 14.2915C229.024 20.201 219.353 29.3777 206.549 26.2816Z",
    fill: "url(#paint2_linear_952_1983)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5631,
    cy: 57.7086,
    r: 5.29715,
    transform: "rotate(-12.0568 32.5631 57.7086)",
    fill: "#266CDA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.582,
    cy: 14.5631,
    r: 5.29715,
    transform: "rotate(-12.0568 234.582 14.5631)",
    fill: "#266CDA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.264,
    cy: 33.579,
    r: 9.78013,
    fill: "#266CDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5723 131.419H15.2305L32.4004 70.0986L49.5723 131.419Z",
    stroke: "#DFECFF",
    strokeWidth: 0.642201
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.739 87.5508H217.397L234.567 26.2305L251.739 87.5508Z",
    stroke: "#B9D3FE",
    strokeWidth: 0.642201
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.104 85.3174C266.104 102.735 251.983 116.855 234.565 116.855C217.147 116.855 203.027 102.735 203.027 85.3174C203.027 85.0942 203.032 84.8715 203.036 84.6494L266.095 84.6494C266.099 84.8715 266.104 85.0942 266.104 85.3174Z",
    fill: "url(#paint3_linear_952_1983)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0762 129.181C63.0762 146.599 48.956 160.719 31.5381 160.719C14.1201 160.719 1.75249e-05 146.599 0 129.181C0 128.958 0.00420123 128.736 0.00878906 128.515H63.0674C63.072 128.736 63.0762 128.958 63.0762 129.181Z",
    fill: "url(#paint4_linear_952_1983)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.704 148.589C123.937 148.206 124.353 147.973 124.801 147.973H143.898C144.349 147.973 144.767 148.209 144.999 148.595L158.358 170.815H110.176L123.704 148.589Z",
    fill: "url(#paint5_linear_952_1983)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2959 171.235C93.2959 170.525 93.8709 169.95 94.5803 169.95H173.946C174.655 169.95 175.23 170.525 175.23 171.235V175.564H93.2959V171.235Z",
    fill: "url(#paint6_linear_952_1983)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3418 175.984C85.3418 175.274 85.9168 174.699 86.6262 174.699H181.865C182.575 174.699 183.15 175.274 183.15 175.984V185.587H85.3418V175.984Z",
    fill: "url(#paint7_linear_952_1983)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_952_1983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6043 128.515H6.78027C8.00818 140.611 11.6922 146.109 16.6043 151.764C21.5165 157.42 35.0234 153.964 27.1099 150.508C20.7791 147.743 17.4683 134.694 16.6043 128.515Z",
    fill: "url(#paint8_linear_952_1983)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_952_1983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.097 84.6494H259.921C258.693 96.5367 255.009 101.94 250.097 107.498C245.185 113.055 231.678 109.659 239.591 106.263C245.922 103.546 249.233 90.7217 250.097 84.6494Z",
    fill: "url(#paint9_linear_952_1983)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_952_1983",
    x: 6.26651,
    y: 128.001,
    width: 23.7892,
    height: 27.2775,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25688,
    result: "effect1_foregroundBlur_952_1983"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_952_1983",
    x: 236.645,
    y: 84.1357,
    width: 23.7892,
    height: 26.8244,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25688,
    result: "effect1_foregroundBlur_952_1983"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_952_1983",
    x1: 117.405,
    y1: 183.201,
    x2: 39.2346,
    y2: 97.7366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C9CE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_952_1983",
    x1: 30.7525,
    y1: 53.3058,
    x2: 55.5066,
    y2: 92.3471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A7EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_952_1983",
    x1: 235.792,
    y1: 9.5119,
    x2: 229.148,
    y2: 55.2595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A7EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_952_1983",
    x1: 255.936,
    y1: 116.855,
    x2: 251.12,
    y2: 85.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A7EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_952_1983",
    x1: 52.9089,
    y1: 160.719,
    x2: 48.0933,
    y2: 129.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A7EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_952_1983",
    x1: 134.354,
    y1: 147.973,
    x2: 132.847,
    y2: 170.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2876F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003A99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_952_1983",
    x1: 134.275,
    y1: 169.95,
    x2: 134.252,
    y2: 175.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2876F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003A99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_952_1983",
    x1: 134.26,
    y1: 174.699,
    x2: 134.187,
    y2: 185.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716346,
    stopColor: "#003A99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_952_1983",
    x1: 11.089,
    y1: 127.359,
    x2: 33.58,
    y2: 159.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2876F1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_952_1983",
    x1: 255.612,
    y1: 83.514,
    x2: 233.644,
    y2: 115.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2876F1",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropsCons);
export default __webpack_public_path__ + "static/media/PropsCons.51491e2ee890871cc6752a0f52fcd5bc.svg";
export { ForwardRef as ReactComponent };